import { cn } from "@/lib/utils"
import { fieldPlaceholder } from '@/lib/form-placeholders'
import { SecretInput, type SecretInputProps } from "./secret-input"
import { DatePicker } from './date-picker'

function Input({ className, type, placeholder, visibilityLabel, ...props }: SecretInputProps) {
  const fieldProps = {
    ...props,
    type,
    "data-slot": "input",
    placeholder: placeholder ?? (props.readOnly ? undefined : fieldPlaceholder({ type, id: props.id, name: props.name, label: props['aria-label'], inputMode: props.inputMode, autoComplete: props.autoComplete })),
    className: cn(
      "form-control selection:bg-primary selection:text-primary-foreground min-h-11 w-full px-3.5 py-2.5 text-base leading-normal md:text-sm file:mr-3 file:rounded-md file:border-0 file:bg-muted file:px-2.5 file:py-1 file:text-sm file:font-medium file:text-foreground",
      className
    ),
  }

  if (type === "password") {
    return <SecretInput {...fieldProps} visibilityLabel={visibilityLabel} />
  }
  if (type === 'date' || type === 'datetime-local') return <DatePicker {...fieldProps} />

  return <input {...fieldProps} />
}

export { Input }
